import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'

import rotasStore from '../../../../store'

import DraggAndDropAvaliacaoAtendimento from '../_components/DraggAndDropAvaliacaoAtendimento'
import { validateData, validateComputed } from '../_validates/validateOcupado'

export const pesquisaSatisfacaoMixins = {
  components: { DraggAndDropAvaliacaoAtendimento },

  data: () => ({
    pesquisas: [],
    avaliacoesSelecionadas: [],
    avaliacoesAtendimento: [],
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...mapGetters('pesquisaSatisfacaoStore', ['getAvaliacoesAtendimento']),
    ...validateComputed,
  },

  async created() {
    registerVuexModule(this.$store, 'pesquisaSatisfacaoStore', rotasStore)
  },

  methods: {
    ...mapActions('pesquisaSatisfacaoStore', ['listarAvaliacoesAtendimento']),

    updateAcoes(event) {
      this.form.acao.pesquisas = event.map(evento => ({ pesquisa: evento.pesquisa, tag: evento.tag }))
    },

    getItemsSelectAvaliacoesAtendimento() {
      this.avaliacoesAtendimento = this.getAvaliacoesAtendimento.map(avaliacaoAtendimento => ({
        text: avaliacaoAtendimento.description,
        value: avaliacaoAtendimento._id,
      }))
    },
  },
}
